import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-transport-type-icon',
  templateUrl: './transport-type-icon.component.html',
  styleUrls: ['./transport-type-icon.component.css']
})
export class TransportTypeIconComponent {


  @Input() type!: number;
  @Input() ship: string | undefined;
}
